// extracted by mini-css-extract-plugin
module.exports = {"sectionBackground":"BlockWrapper_sectionBackground__LBO2D"};